






import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import {MAFUser} from '@/store/User/types';
import {Action, Mutation, Getter, namespace, State} from 'vuex-class';
import luxon from '@/plugins/luxon';
import * as _ from 'lodash';
import {MAFViolation} from '@/store/Violations/types';
import {User} from 'firebase'; // @ is an alias to /src
import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;

@Component({
    components: {
    },
})
export default class ArchiveUserModal extends Vue {
}
